import { act } from '../../jsx-act'
import './radio-group.scss'
import SpaceBetween from './space-between';

interface RadioGroupProps {
  name: string;
  onChange?: (event: CustomEvent<{ value: string }>) => void;
  initialValue?: string
  ariaLabel?: string;
  items?: {
    value: string;
    label?: string;
    disabled?: boolean;
  }[]
}

export const RADIO_GROUP_INPUT_NAME_PREFIX = 'awsccc-u-rg-';
export default ({ name, items = [], initialValue, onChange = () => null, ariaLabel }: RadioGroupProps) => {
  let value = initialValue

  const handleChange = (newValue: string) => {
    value = newValue;
    onChange(new CustomEvent('change', { detail: { value: newValue }}))
  }

  return (
    <div class="awsccc-u-rg" role='radiogroup' aria-label={ariaLabel}>
      <SpaceBetween direction='vertical' size='xxs'>
        {items.map(item => (
          <label>
            <input
              type="radio"
              name={`${RADIO_GROUP_INPUT_NAME_PREFIX}${name}`}
              value={item.value}
              checked={item.value === value ? true : undefined}
              disabled={item.disabled ? true : undefined}
              onChange={(e) => e.target.checked ? handleChange(item.value) : null}
            />
            <span class="awsccc-u-rg-radio" />
            <span>{item.label || item.value}</span>
          </label>
        ))}
      </SpaceBetween>
    </div>
  )
}
